document.addEventListener('alpine:init', () => {
    Alpine.data('Theme_RecentlyViewedProducts', () => {
      return {
        ready: false,
        loading: true,
        content: '',
        async init() {
          const product_ids = Alpine.store('product').getRecentlyViewedIds();
          if(product_ids.length == 0){
            return
          }
          await this._resetFromSearch(product_ids);
          await this.$nextTick();
          this.initSlideshow();
        },
        async _resetFromSearch(product_ids) {
          const queryString = product_ids.map(function (item) {
            return 'id:' + item;
            }).join(' OR ');
            this.loading = true;
            try{
                const htmlContent = fetchHTMLFragment(window.theme.routes.search_url + '?view=product-carousel&type=product&q=' + queryString, '#results');
                this.content = htmlContent;
            }finally{
                this.loading =false
            }
        }
      };
    });

  });
  